/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_TitleInputs */

const en_load_project_file_title = /** @type {(inputs: Load_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project File Loader`)
};

const fr_load_project_file_title = /** @type {(inputs: Load_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargeur de fichier projet`)
};

const de_load_project_file_title = /** @type {(inputs: Load_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektdatei-Lader`)
};

const it_load_project_file_title = /** @type {(inputs: Load_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricatore di file di progetto`)
};

const ru_load_project_file_title = /** @type {(inputs: Load_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузчик файлов проекта`)
};

const es_load_project_file_title = /** @type {(inputs: Load_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargador de archivos de proyecto`)
};

const zh_cn2_load_project_file_title = /** @type {(inputs: Load_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目文件加载器`)
};

const ja_load_project_file_title = /** @type {(inputs: Load_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトファイルローダー`)
};

const hi_load_project_file_title = /** @type {(inputs: Load_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट फ़ाइल लोडर`)
};

const pt_pt2_load_project_file_title = /** @type {(inputs: Load_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregador de Arquivos de Projeto`)
};

/**
* | output |
* | --- |
* | "Project File Loader" |
*
* @param {Load_Project_File_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_title = /** @type {((inputs?: Load_Project_File_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_title(inputs)
	if (locale === "de") return de_load_project_file_title(inputs)
	if (locale === "it") return it_load_project_file_title(inputs)
	if (locale === "ru") return ru_load_project_file_title(inputs)
	if (locale === "es") return es_load_project_file_title(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_title(inputs)
	if (locale === "ja") return ja_load_project_file_title(inputs)
	if (locale === "hi") return hi_load_project_file_title(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_title(inputs)
	return en_load_project_file_title(inputs)
});